/**
 * Define find account mixin
 *
 * @author minkyoung.park@emcast.com
 */

export const findIdMixin = {
    methods: {
        // guide Popup 
        showMessage(mode) {
            if (mode === 1) {
                this.$confirm({
                    title: this.$t('54'), //코드를 받지 못했습니까?
                    content: this.$t('55') + '<br>' + this.$t('56', {str: '<a href="mailto:'+BRAND_MANAGER_EMAIL+'">'+BRAND_MANAGER_EMAIL+'</a>'}) + '</a><br>' + this.$t('57', {str: '<a href="tel:'+BRAND_MANAGER_PHONE+'">'+BRAND_MANAGER_PHONE+'</a>'}), //코드를 재전송하거나 관리자에게 문의하실 수 있습니다.E-MAIL : koica@emcast.com 문의처 : 82.02.541.7381
                    accept:  this.$t('58'), //코드 재전송
                    cancel:  this.$t('51'), //닫기
                }).then(() => {
                    // this.$router.go(-1)
                    this.getReCertiNumber()
                })
            }else if (mode === 2) {
                this.$error({
                    title: this.$t('59'),   //다시 로그인해보기
                    content: this.$t('60') +' '+ this.$t('61'), //더 이상 해당 번호를 사용할 수 없다면 다시 로그인해보세요. 로그인 후 회원님의 계정에서 휴대폰 번호를 변경할 수 있습니다.
                    accept: this.$t('62'),
                    cancel: ''
                }).then(() => {}).catch(() => {
                    this.$moveLogin()
                })
            }
        },
        // find account cancel popup
        cancelFindId() {
            this.$confirm({   
                title: this.$t('10'),   //비밀번호 재설정을 취소하시겠습니까?
                content: this.$t('22'), //'계정찾기를 취소하시겠습니까? <br>확인을 누르면 취소됩니다.',
                accept:  this.$t('137'),
                cancel: this.$t('136'),
            }).then(() => {
                this.$moveLogin()
            }).catch(() => {
                
            })
        },
        // find password cancel popup
        cancelFindPw() {
            this.$confirm({
                title: this.$t('11'),   //비밀번호 재설정을 취소하시겠습니까?
                content: this.$t('430'),//'비밀번호 재설정을 취소하시겠습니까? <br>확인을 누르면 취소됩니다.',
                accept:  this.$t('432'),
                cancel: this.$t('431'),
            }).then(() => {
                this.$moveLogin()
            }).catch(() => {
                
            })
        },
        // find code cancel popup
        cancelFindCode() {
            this.$confirm({
                title: this.$t('10'),   //비밀번호 재설정을 취소하시겠습니까?
                content: this.$t('22'),//'비밀번호 재설정을 취소하시겠습니까? <br>확인을 누르면 취소됩니다.',
                accept:  this.$t('136'),
                cancel: this.$t('137'),
            }).then(() => {
                this.$moveLogin()
            }).catch(() => {
                
            })
        }
        
    }
}